import { transparentize } from 'polished';
import styled, { css } from 'styled-components';

interface IFormAuthSelectContainer {
  openOption: boolean;
  showContent: boolean;
}
interface IFormAuthSelectComponent {
  openOption: boolean;
  istransform?: boolean;
}

export const SelectCollectToBondWithTankContainer = styled.div<IFormAuthSelectContainer>`
  width: 100%;

  h2 {
    margin-bottom: 0.3rem;
  }

  .list-options {
    z-index: 100;
    position: relative;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    height: auto;
    max-height: ${({ openOption }) => (openOption ? `220px` : '0px')};
    background-color: ${({ theme }) => transparentize(0.8, theme.COLORS.GREY)};
    border-radius: 0 0 0.6rem 0.6rem;
    transition: 0.3s all;

    .column {
      display: flex;
      flex-direction: column;
    }
  }
`;

export const CollectItem = styled.div<{
  $isDivergent?: boolean;
  $isLast?: boolean;
}>`
  padding: 0.6rem;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  cursor: pointer;
  border-bottom: ${({ $isLast }) => ($isLast ? 'none' : '1px solid gray')};
  border-left: ${({ $isDivergent }) =>
    $isDivergent ? '3px solid #f97316' : 'none'};

  span {
    font-size: 1.1rem;
    color: black;
  }

  &:hover {
    transition: 0.3s all;
    background-color: ${({ theme }) =>
      transparentize(0.8, theme.COLORS.GREY_50)};
  }
`;

export const DivergenceLabel = styled.span`
  color: #f97316;
`;

export const EmptyState = styled.span`
  padding: 0.6rem;
  color: black;
`;

export const SelectCollectToBondWithTankComponent = styled.div<IFormAuthSelectComponent>`
  transition: 0.3s all;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-direction: row;
  width: 100%;
  max-height: 70px;
  border-radius: 0.6rem;
  ${({ openOption }) =>
    openOption &&
    css`
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    `}
  padding: 0.5rem 1rem;
  background-color: ${({ theme }) => transparentize(0.2, theme.COLORS.GREY)};
  transition: 0.3s ease-out;
  z-index: 99;
  position: relative;

  svg {
    transition: 0.3s all;
    width: 25px;
    height: 25px;
  }

  .select-options-container {
    transition: 0.3s all;
    width: 90%;
    height: 100%;
    border: 0;
    /* border-left: 1px solid white; */
    padding: 0 1rem;
    background-color: transparent;
    outline: none;
    color: ${({ theme }) => theme.COLORS.WHITE};
    align-items: center;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    .select {
      cursor: pointer;
      position: relative;
      left: 20px;
      transform: ${({ openOption }) =>
        openOption ? 'rotate(180deg)' : 'rotate(0deg)'};
    }
    svg {
      transition: 0.3s all;
      width: 15px;
      height: 15px;
    }
    p {
      font-size: 1rem;
      color: ${({ theme }) => transparentize(0.6, theme.COLORS.WHITE)};
    }
    @media (max-width: 750px) {
      font-size: 0.8rem;
    }
  }
`;
